import { useGetInstitutionQuery } from "@lending/hooks/queries/useGetInstitutionQuery";
import { LegacyOffers } from "./LegacyOffers";
import { SliderOffers } from "./SliderOffers";

function Offers() {
  const { institution } = useGetInstitutionQuery();

  if (institution.lending_personal_loan_term_slider_enabled) {
    return <SliderOffers />;
  }

  return <LegacyOffers />;
}

export { Offers };
